import { LabelsMap } from 'new/form/common/types';

import { contactPersonSectionLabels } from './sections/contactPerson/labels';
import { passwordSectionLabels } from './sections/passwordSection/labels';

export const mittweidaUserProfileLabelsMap: LabelsMap = {
  ...contactPersonSectionLabels,
  ...passwordSectionLabels,
};
